import { render, staticRenderFns } from "./studentBrochure.vue?vue&type=template&id=895eba62&scoped=true"
import script from "./studentBrochure.vue?vue&type=script&lang=js"
export * from "./studentBrochure.vue?vue&type=script&lang=js"
import style0 from "./studentBrochure.vue?vue&type=style&index=0&id=895eba62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895eba62",
  null
  
)

export default component.exports